var loadItems = function(button) {
  var totalPages = parseInt(document.querySelector('[data-total-pages]').value);
  var currentPageInput = document.querySelector('[data-current-page]');
  var currentPage = parseInt(currentPageInput.value) + 1;
  var nextUrlInput = document.querySelector('[data-next-url]');
  var nextUrl = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPage);
  currentPageInput.value = currentPage;
  button.setAttribute('disabled', '');
  button.classList.add('loading');
  fetch(nextUrl)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newItems = tmp.querySelector('.load-more-grid');
      if (newItems) document.querySelector('.load-more-grid').insertAdjacentHTML('beforeend', newItems.innerHTML);
      if (typeof colorSwatches === 'function') colorSwatches();
    })
    .finally(function() {
      if (currentPage <= totalPages) {
        var scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          var nui = scollData.querySelector('input[data-next-url]');
          var cpi = scollData.querySelector('input[data-current-page]');
          var nextUrlScroll = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + (currentPage + 1));
          if (nui) { nui.dataset.nextUrl = nextUrlScroll; nui.value = nextUrlScroll; }
          if (cpi) { cpi.dataset.currentPage = currentPage; cpi.value = currentPage; }
          checkVisibility();
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage == totalPages) button.remove();
      }
    });
};
var checkVisibility = function() {
  document.querySelectorAll('.js-infinite-scroll').forEach(function(spinner) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { if (entry.isIntersecting) loadItems(spinner); });
    }).observe(spinner);
  });
};
function loadMore() {
  document.querySelectorAll('.js-load-more').forEach(function(button) { button.onclick = function() { loadItems(button); }; });
  checkVisibility();
}
(function() { loadMore(); })();
